import { Injectable } from "@angular/core";
import { FormArray, FormControlStatus, FormGroup } from "@angular/forms";
import {
  BaseFpxComponentState,
  BaseFpxFormHelper,
  HttpProviderService,
  IHttpSuccessPayload,
  RoutingInfo,
  BaseFpxChangeHandler,
  BaseFpxControlEventHandler,
  HttpRequest,
  SpinnerService,
  ILookupResponse,
  FpxModal,
  CriteriaQuery
} from "@fpx/core";
import { Observable, map, of } from "rxjs";
import { Router } from "@angular/router";
import { RloapplicationService } from '../rloapplication-service/rloapplication.service';
import { Rloapplication } from '../rloapplication-service/rloapplication.model';
import { MatDialogRef } from "@angular/material/dialog";
import { RloApplicationSortFormComponent } from "./rlo-application-sort-form.component";
import { PopupService } from "src/app/common/services/popup/popup.service";
import { RloApplicationFormHelper } from "../rlo-application-form/rlo-application-form.helper";
import { CommonService } from "src/app/common.service";

export class RloApplicationSortFormState extends BaseFpxComponentState {
 	showSuggestion : boolean = false;
}


@Injectable()
export class RloApplicationSortFormHelper extends BaseFpxFormHelper<RloApplicationSortFormState>{

  applicantName:any;
  arn:any;
  type:any;
  period:any;
  stage:any;
  tat:any;
  criteriaQuery=new CriteriaQuery();
  action: number;

   constructor(
    private _httpProvider : HttpProviderService,
    private _router: Router,
    private _popupService:PopupService,
    private dialogRef: MatDialogRef<RloApplicationSortFormComponent>,
    private _rloapplicationService:RloapplicationService,
    public _commonService: CommonService
    )
    {
        super(new RloApplicationSortFormState());
        this.addChangeHandler('applicantName',this.applicantNameChange);
        this.addChangeHandler('arn',this.arnChange);
        this.addChangeHandler('type',this.typeChange);
        this.addChangeHandler('stage',this.stageChange);
        this.addChangeHandler('period',this.periodChange);
        this.addChangeHandler('tat',this.tatChange);
    }

    private applicantNameChange: BaseFpxChangeHandler = (
      name: string,
      status: FormControlStatus,
      value: any,
      formGroup: FormGroup
      ) => {
         // WRITE CODE HERE TO HANDLE
         if(value){
          this.formGroup.get('arn').disable({ emitEvent: false });
          this.formGroup.get('type').disable({ emitEvent: false });
          this.formGroup.get('stage').disable({ emitEvent: false });
          this.formGroup.get('period').disable({ emitEvent: false });
          this.formGroup.get('tat').disable({ emitEvent: false });
         }
    }
  private arnChange: BaseFpxChangeHandler = (
    name: string,
    status: FormControlStatus,
    value: any,
    formGroup: FormGroup
    ) => {
       // WRITE CODE HERE TO HANDLE
       if(value){
       this.formGroup.get('applicantName').disable({ emitEvent: false });
       this.formGroup.get('type').disable({ emitEvent: false });
       this.formGroup.get('stage').disable({ emitEvent: false });
       this.formGroup.get('period').disable({ emitEvent: false });
       this.formGroup.get('tat').disable({ emitEvent: false });
       }
  }
  private tatChange: BaseFpxChangeHandler = (
    name: string,
    status: FormControlStatus,
    value: any,
    formGroup: FormGroup
    ) => {
       // WRITE CODE HERE TO HANDLE
       if(value){
       this.formGroup.get('arn').disable({ emitEvent: false });
       this.formGroup.get('type').disable({ emitEvent: false });
       this.formGroup.get('stage').disable({ emitEvent: false });
       this.formGroup.get('period').disable({ emitEvent: false });
       this.formGroup.get('applicantName').disable({ emitEvent: false });
       }
  }
  private periodChange: BaseFpxChangeHandler = (
    name: string,
    status: FormControlStatus,
    value: any,
    formGroup: FormGroup
    ) => {
       // WRITE CODE HERE TO HANDLE
       if(value){
       this.formGroup.get('arn').disable({ emitEvent: false });
       this.formGroup.get('type').disable({ emitEvent: false });
       this.formGroup.get('stage').disable({ emitEvent: false });
       this.formGroup.get('applicantName').disable({ emitEvent: false });
       this.formGroup.get('tat').disable({ emitEvent: false });
       }
  }
  private stageChange: BaseFpxChangeHandler = (
    name: string,
    status: FormControlStatus,
    value: any,
    formGroup: FormGroup
    ) => {
       // WRITE CODE HERE TO HANDLE
       if(value){
       this.formGroup.get('arn').disable({ emitEvent: false });
       this.formGroup.get('type').disable({ emitEvent: false });
       this.formGroup.get('applicantName').disable({ emitEvent: false });
       this.formGroup.get('period').disable({ emitEvent: false });
       this.formGroup.get('tat').disable({ emitEvent: false });
       }
  }
  private typeChange: BaseFpxChangeHandler = (
  name: string,
  status: FormControlStatus,
  value: any,
  formGroup: FormGroup
  ) => {
     // WRITE CODE HERE TO HANDLE
     if(value){
     this.formGroup.get('arn').disable({ emitEvent: false });
     this.formGroup.get('applicantName').disable({ emitEvent: false });
     this.formGroup.get('stage').disable({ emitEvent: false });
     this.formGroup.get('period').disable({ emitEvent: false });
     this.formGroup.get('tat').disable({ emitEvent: false });
     }
}
  override doPreInit(): void {

 }

private handleAppRefOnvalueChange: BaseFpxChangeHandler = (
		name: string,
		status: FormControlStatus,
		value: any,
		formGroup: FormGroup
		) => {
		   // WRITE CODE HERE TO HANDLE
}

  public override doPostInit(): void {
    this.action=0;
    if(this._rloapplicationService.sortApplied){
    if (this._rloapplicationService.sort_applicantName)
      this.formGroup.get('applicantName').patchValue(this._rloapplicationService.sort_applicantName);
    if (this._rloapplicationService.sort_arn)
      this.formGroup.get('arn').patchValue(this._rloapplicationService.sort_arn);
    if (this._rloapplicationService.sort_type)
      this.formGroup.get('type').patchValue(this._rloapplicationService.sort_type);
    if (this._rloapplicationService.sort_period)
      this.formGroup.get('period').patchValue(this._rloapplicationService.sort_period);
    if (this._rloapplicationService.sort_stage)
      this.formGroup.get('stage').patchValue(this._rloapplicationService.sort_stage);
    if (this._rloapplicationService.sort_tat)
      this.formGroup.get('tat').patchValue(this._rloapplicationService.sort_tat);
    }
  }


  public override preSubmitInterceptor(payload: Rloapplication):any {
     // WRITE CODE HERE TO HANDLE
    return payload;
  }

  public override postSubmitInterceptor(response:any): RoutingInfo {
    console.log(response);
    let routingInfo: RoutingInfo = new RoutingInfo();
    routingInfo.setNavigationURL("confirmation");
    if (response.success) {
      routingInfo.setQueryParams({
        transRef: response.success?.body?.fpxdeposit?.depositRef,
        status: "success",
      });
    } else if (response.error) {
      routingInfo.setQueryParams({ status: "failed" });
    }
    return routingInfo;
  }
  closeSort(action: string = ''){
  if(this.action==1)
    this.dialogRef.close(1);
  else
    this.dialogRef.close();
  }
  resetSortData(){
    this._rloapplicationService.criteriaQuery._sortCriteria=new Map();
    this._rloapplicationService.sort_applicantName="";
    this._rloapplicationService.sort_arn="";
    this._rloapplicationService.sort_type="";
    this._rloapplicationService.sort_period="";
    this._rloapplicationService.sort_stage="";
    this._rloapplicationService.sort_tat="";
  }
  clearSort(){
    this.formGroup.reset();
    this._rloapplicationService.sortApplied=false;
    this.formGroup.enable({ emitEvent: false });
    this.resetSortData();
    this.action=1;
  }
  applySort(){
    this._rloapplicationService.sortApplied=false;
    this.applicantName=this.formGroup.get('applicantName').value;
    this.arn=this.formGroup.get('arn').value;
    this.type=this.formGroup.get('type').value;
    this.period=this.formGroup.get('period').value;
    this.stage=this.formGroup.get('stage').value;
    this.tat=this.formGroup.get('tat').value;

    if(this._rloapplicationService.filterApplied)
      this.criteriaQuery=this._rloapplicationService.criteriaQuery;

    if(this.arn){
      this._rloapplicationService.sortApplied = true;
      this._rloapplicationService.sort_arn=this.arn;
      this.criteriaQuery.addSortCriteria(this._rloapplicationService.arnColumn, this.arn, 'String');
    }
    if(this.period){
      this._rloapplicationService.sortApplied = true;
      this._rloapplicationService.sort_period=this.period;
      this.criteriaQuery.addSortCriteria(this._rloapplicationService.periodColumn, this.period, 'String');
    }
    if(this.applicantName){
      this._rloapplicationService.sortApplied = true;
      this._rloapplicationService.sort_applicantName=this.applicantName;
      this.criteriaQuery.addSortCriteria(this._rloapplicationService.applicantNameColumn, this.applicantName, 'String');
    }
    if(this.type){
      this._rloapplicationService.sortApplied = true;
      this._rloapplicationService.sort_type=this.type;
      this.criteriaQuery.addSortCriteria(this._rloapplicationService.typeColumn, this.type, 'String');
    }
    if(this.stage){
      this._rloapplicationService.sortApplied = true;
      this._rloapplicationService.sort_stage=this.stage;
      this.criteriaQuery.addSortCriteria(this._rloapplicationService.stageColumn, this.stage, 'String');
    }
    if(this.tat){
      this._rloapplicationService.sortApplied = true;
      this._rloapplicationService.sort_tat=this.tat;
      this.criteriaQuery.addSortCriteria(this._rloapplicationService.tatColumn, this.tat, 'String');
    }
    this._rloapplicationService.criteriaQuery=this.criteriaQuery;
    this.dialogRef.close(1);
    this._commonService.showSpinner();
  }
 //$START_CUSTOMSCRIPT\n
 //$END_CUSTOMSCRIPT\n
}
